import { useState } from "react";
import { Switch } from "@/components/ui/switch";
import { Tag, X } from "lucide-react";

export const PicSettingsBar = ({ settings, onSave }) => {
  const [tagInput, setTagInput] = useState("");
  const tags = settings.default_tags || [];

  const addTag = () => {
    const t = tagInput.trim();
    if (t && !tags.includes(t)) onSave({ ...settings, default_tags: [...tags, t] });
    setTagInput("");
  };

  return (
    <div className="content-card" data-testid="pic-settings-bar" style={{ display: "flex", flexWrap: "wrap", gap: 24, alignItems: "flex-start" }}>
      <div style={{ flex: "1 1 280px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <Switch checked={settings.auto_import} disabled={!!settings.loading} onCheckedChange={(v) => onSave({ ...settings, auto_import: v })} data-testid="pic-auto-import-switch" />
          <span style={{ fontWeight: 600 }}>{settings.auto_import ? "Import right away" : "Review before import"}</span>
        </div>
        <p style={{ color: "#64748b", fontSize: 13, marginTop: 6 }}>
          {settings.auto_import
            ? "Contacts are sent to your CRM as soon as they're read. You can still see them below."
            : "You check and fix each contact before it's sent to your CRM."}
        </p>
      </div>
      <div style={{ flex: "1 1 320px" }}>
        <label className="form-label" style={{ display: "flex", alignItems: "center", gap: 6 }}><Tag size={14} /> CRM tags for new contacts</label>
        <div style={{ display: "flex", gap: 8 }}>
          <input className="form-input" placeholder="e.g. trade-show-2026" value={tagInput} data-testid="pic-tag-input"
            onChange={(e) => setTagInput(e.target.value)} onKeyDown={(e) => e.key === "Enter" && addTag()} />
          <button type="button" className="btn btn-secondary" onClick={addTag} data-testid="pic-tag-add-btn">Add</button>
        </div>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginTop: 8 }}>
          <span style={chip("#f1f5f9", "#475569")}>pic-to-lead</span>
          {tags.map((t) => (
            <span key={t} style={chip("#dbeafe", "#1d4ed8")} data-testid={`pic-tag-${t}`}>
              {t}
              <X size={12} style={{ cursor: "pointer" }} onClick={() => onSave({ ...settings, default_tags: tags.filter((x) => x !== t) })} />
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

const chip = (bg, color) => ({ background: bg, color, borderRadius: 999, padding: "3px 10px", fontSize: 12, display: "inline-flex", alignItems: "center", gap: 4 });
